import { Pips } from "common/Pips";
import { CTA } from "common/styleguide/CTA";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import blueTheme from "common/styleguide/ModalOverlay/blueHeaderModalTheme.scss";
import { messages as paymentFormMessages } from "features/payments/PaymentForm";
import { commonCTAs, Msg, useFormatMessage } from "lib/localization";
import { introText } from "lib/styleguide/base.scss";
import { getCurrentUser } from "lib/utils";
import _ from "lodash";
import React, { useState } from "react";
import styles from "./CarouselModal.scss";
import { descriptions, featureData, names } from "./features";
import { messages as upgradeModalMessages } from "./UpgradeModal";

export const CAROUSEL_MODAL = "CAROUSEL_MODAL";

export const CarouselModal = ({ onRequestClose, feature, helpPathMessage, onUpgrade, onCreateAccount }) => {
  const fm = useFormatMessage();
  const [activeFeature, setActiveFeature] = useState(0);
  const hasUser = !!_.get(window, "rwgps.config.currentUser.id");
  const features = [feature, "advancedRouteEditing", "plannerMobile"];
  const data = featureData[features[activeFeature]];
  if (!data) {
    throw Error(`Unknown CarouselModal feature "${feature}"`);
  }
  const { assetType, helpPath } = data;
  const upgradePath = `/subscriptions/new?account_level=premium${
    getCurrentUser().eligibleForOnetimeTrial ? "&trial=1" : ""
  }`;
  const upgradeText = (
    <Msg m={getCurrentUser().eligibleForOnetimeTrial ? commonCTAs.startFreeTrial : commonCTAs.upgradeNow} />
  );
  const video = assetType === "webm";

  const context = require.context("./img", false, /.*/);

  const asset = (name, ext) => context(`./${name}.${ext}`);

  const redirectParam = `redirect_to=${encodeURIComponent(window.location.href)}`;

  const bigCTA = hasUser ? (
    onUpgrade ? (
      <CTA
        onClick={() => {
          onRequestClose();
          onUpgrade();
        }}
      >
        {upgradeText}
      </CTA>
    ) : (
      <CTA href={upgradePath}>{upgradeText}</CTA>
    )
  ) : onCreateAccount ? (
    <CTA
      onClick={() => {
        onRequestClose();
        onCreateAccount();
      }}
    >
      {fm(upgradeModalMessages.createAccount)}
    </CTA>
  ) : (
    <CTA href={`/signup?${redirectParam}`}>{fm(upgradeModalMessages.createAccount)}</CTA>
  );

  return (
    <ModalOverlay
      className={styles.CarouselModal}
      maxWidth="800px"
      shouldCloseOnOverlayClick
      title={fm(paymentFormMessages.upToPremium)}
      onRequestClose={onRequestClose}
      footer={
        <div className={styles.ctaContainer}>
          <CTA link href={helpPath}>
            {fm(helpPathMessage || commonCTAs.learnMore)}
          </CTA>
          {bigCTA}
        </div>
      }
      theme={blueTheme}
    >
      <div className={styles.TipsCarousel}>
        <div className={styles.imgContainer} onClick={() => setActiveFeature((activeFeature + 1) % features.length)}>
          {video && (
            <video autoPlay loop muted key={activeFeature}>
              {features[activeFeature] === "plannerMobile" && (
                <source src="/images/mrp/mrp-top-demo.mp4" type={`video/mp4`} />
              )}
              {features[activeFeature] !== "plannerMobile" && (
                <>
                  <source src={asset(features[activeFeature], "mp4")} type={`video/mp4`} />
                  <source src={asset(features[activeFeature], "webm")} type={`video/webm`} />
                </>
              )}
            </video>
          )}
          {!video && <img src={asset(features[activeFeature], assetType)} />}
        </div>
        <p className={styles.title}>{fm(names[features[activeFeature]], { count: 0 })}</p>
        <p className={introText}>{fm(descriptions[features[activeFeature]])}</p>
        <Pips stepCount={features.length} activeIndex={activeFeature} onClickPip={setActiveFeature} />
      </div>
    </ModalOverlay>
  );
};
